module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/vi_1-84c0bee9557e448d2db9b3b07184abf3.jpg";